module.exports = __webpack_public_path__ + "img/Sicbo-UI.fe07b739.jpg";